'use client';

const pillars = [
  {
    number: '01',
    title: 'Single Window Expertise',
    desc: 'From registration to scaling — legal, financial, digital and tech solutions managed under one roof by dedicated specialists.',
  },
  {
    number: '02',
    title: 'Transparent Pricing',
    desc: 'No hidden costs. Fixed, upfront pricing for every service with milestone-based billing you can trust.',
  },
  {
    number: '03',
    title: 'Pan-India Reach',
    desc: 'Registered in any state across India. We handle state-specific compliances, filings and regulatory nuances seamlessly.',
  },
  {
    number: '04',
    title: 'Dedicated Relationship Manager',
    desc: 'A single point of contact who understands your business — available for calls, updates and ongoing advisory at every stage.',
  },
];

const advantages = [
  { label: 'ISO Certified', value: '9001:2015' },
  { label: 'States Covered', value: '28+' },
  { label: 'Avg. Turnaround', value: '72 hrs' },
  { label: 'Services Offered', value: '50+' },
];

export function WhyChooseUs() {
  return (
    <section className="bg-slate-50 py-16 lg:py-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">

          {/* Left — Image */}
          <div className="relative">
            <div className="relative rounded-md overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?w=900&q=80"
                alt="Farsight Solutions Team"
                className="w-full h-80 lg:h-[420px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent" />
            </div>

            {/* Floating badge */}
     

            {/* Mini stats row */}
            <div className="grid grid-cols-2 gap-3 mt-8">
              {advantages.map((a) => (
                <div key={a.label} className="bg-white rounded-xl p-4 shadow-sm border border-slate-100 text-center">
                  <div
                    className="text-xl font-bold"
                    style={{
                      fontFamily: "'Sora', sans-serif",
                      background: 'linear-gradient(135deg, #d97706, #f59e0b)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                    }}
                  >
                    {a.value}
                  </div>
                  <div className="text-slate-500 text-xs mt-0.5">{a.label}</div>
                </div>
              ))}
            </div>
          </div>

          {/* Right — Content */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <div className="h-px w-8 bg-amber-500" />
              <span className="text-amber-600 text-xs font-semibold tracking-[0.18em] uppercase">Why Farsight</span>
            </div>
            <h2
              className="text-3xl lg:text-4xl font-bold text-slate-900 leading-tight mb-4"
              style={{ fontFamily: "'Sora', sans-serif" }}
            >
              The Smartest Choice for Ambitious Indian Businesses
            </h2>
            <p className="text-slate-500 text-base leading-relaxed mb-8">
              We are not just a service provider — we are your growth partners. Our integrated approach means every decision, compliance and strategy works in sync to accelerate your business.
            </p>

            {/* Pillars */}
            <div className="space-y-5">
              {pillars.map((p) => (
                <div key={p.number} className="flex gap-4 group">
                  <div
                    className="flex-shrink-0 w-10 h-10 rounded-lg flex items-center justify-center text-xs font-bold text-white mt-0.5"
                    style={{ background: 'linear-gradient(135deg, #92400e, #d97706)' }}
                  >
                    {p.number}
                  </div>
                  <div>
                    <h4 className="text-slate-900 font-semibold text-sm mb-1">{p.title}</h4>
                    <p className="text-slate-500 text-sm leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-8">
              <a
                href="/about"
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-sm font-semibold text-sm text-white tracking-wide transition-all duration-300 hover:shadow-lg hover:shadow-amber-500/30 hover:-translate-y-0.5"
                style={{ background: 'linear-gradient(135deg, #d97706, #f59e0b)' }}
              >
                About Farsight Solutions
                <span>→</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}